import type { BookingStatus } from '@/components/BookingCalendar';

export type StaffConfig = {
  id: number;
  name: string;
  color: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  defaults: {
    amount: number;
    status: BookingStatus;
    duration: string;
  };
};

export const staffConfig: StaffConfig[] = [
  {
    id: 1,
    name: 'Sergio',
    color: 'text-blue-600 bg-blue-50',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    defaults: {
      amount: 0,
      status: 'pending',
      duration: '2'
    }
  },
  {
    id: 2,
    name: 'Martin',
    color: 'text-purple-600 bg-purple-50',
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-600',
    borderColor: 'border-purple-500',
    defaults: {
      amount: 0,
      status: 'pending',
      duration: '2'
    }
  },
  {
    id: 3,
    name: 'Topi',
    color: 'text-emerald-600 bg-emerald-50',
    bgColor: 'bg-emerald-50',
    textColor: 'text-emerald-600',
    borderColor: 'border-emerald-500',
    defaults: {
      amount: 0,
      status: 'pending',
      duration: '2'
    }
  },
  {
    id: 4,
    name: 'SuHe',
    color: 'text-rose-600 bg-rose-50',
    bgColor: 'bg-rose-50',
    textColor: 'text-rose-600',
    borderColor: 'border-rose-500',
    defaults: {
      amount: 0,
      status: 'booked',
      duration: '1'
    }
  }
];

export const getStaffConfig = (name: string): StaffConfig | undefined => {
  return staffConfig.find(staff => staff.name === name);
};

export const getStaffById = (id: number): StaffConfig | undefined => {
  return staffConfig.find(staff => staff.id === id);
};

export const getStaffColor = (name: string): string => {
  return getStaffConfig(name)?.color || '';
};

export const getStaffStyles = (name: string) => {
  const config = getStaffConfig(name);
  if (!config) return {};
  
  return {
    bgColor: config.bgColor,
    textColor: config.textColor,
    borderColor: config.borderColor
  };
};